export default __webpack_public_path__ + "static/media/Hubano-2Closed.aa9246fd.jpg";